export const GET_LIST = 'app/reps/GET_LIST';
export const CREATE_ONE = 'app/reps/CREATE_ONE';
export const GET_ONE = 'app/reps/GET_ONE';
export const EDIT_ONE = 'app/reps/EDIT_ONE';
export const EDIT_ONE_ROLE = 'app/reps/EDIT_ONE_ROLE';
export const ACTIVE_DEALERSHIP = 'app/reps/ACTIVE_DEALERSHIP';
export const UPLOAD_REPS = 'app/reps/UPLOAD_REPS';
